module.exports = __webpack_public_path__ + "media/packs/user-cards/images/no-cards-9a590aec47de4b554c7791e387b70c43.svg";